export default function WhenNeeded() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const signals = [
    { icon: 'ri-arrow-down-line', text: 'Конверсия звонков низкая — менеджеры делают много звонков, но мало встреч' },
    { icon: 'ri-emotion-sad-line', text: 'Менеджеры боятся звонить — холодные звонки вызывают стресс и прокрастинацию' },
    { icon: 'ri-close-circle-line', text: 'Много отказов — клиенты прерывают разговор на первых фразах' },
    { icon: 'ri-lock-line', text: 'Не проходят секретаря — не могут выйти на лицо, принимающее решение' },
    { icon: 'ri-calendar-2-line', text: 'Не могут назначить встречу — разговор заканчивается ничем' },
    { icon: 'ri-money-dollar-circle-line', text: 'Клиенты говорят «дорого» — менеджеры сразу уходят в скидки' },
    { icon: 'ri-presentation-line', text: 'Менеджеры уходят в презентацию — начинают рассказывать о продукте до понимания потребности' },
    { icon: 'ri-dislike-line', text: 'Отдел не любит холодные звонки — низкая мотивация и текучка' },
    { icon: 'ri-timer-line', text: 'Низкая активность — мало звонков, нет системы ежедневной работы' },
    { icon: 'ri-file-list-2-line', text: 'Нет системы — каждый менеджер работает по-своему, нет единого стандарта' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Когда нужен этот тренинг
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Если вы узнали свою компанию хотя бы в трёх пунктах — обучение телефонным продажам окупится в первые недели после внедрения.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 max-w-5xl mx-auto">
          {signals.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 border border-orange-100 hover:border-orange-200 transition-colors group">
              <div className="w-10 h-10 bg-orange-50 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-orange-100 transition-colors">
                <i className={`${item.icon} text-orange-500 text-lg`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить программу обучения
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}